import React, { useState } from "react";
import { motion } from "framer-motion";
import SEO from "../components/SEO";
import VastuCompassPlaceholder from "../components/VastuCompassPlaceholder";
import { NavLink } from "react-router-dom";
import { logActivity } from "../utils/activity";
import featuresData from "../data/features.json";

export default function Features() {
  const [active, setActive] = useState(featuresData.features[0]);
  const featureAnimations = {
    "Devtas calculation": {
      hidden: { opacity: 0, y: 18 },
      visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
    },
    "Ayadi calculator": {
      hidden: { opacity: 0, scale: 0.96 },
      visible: { opacity: 1, scale: 1, transition: { duration: 0.4 } },
    },
    Numerology: {
      hidden: { opacity: 0, x: -14 },
      visible: { opacity: 1, x: 0, transition: { duration: 0.4 } },
    },
    "Astro Vastu": {
      hidden: { opacity: 0, x: 14 },
      visible: { opacity: 1, x: 0, transition: { duration: 0.4 } },
    },
    "Lal Kitab": {
      hidden: { opacity: 0, y: -14 },
      visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
    },
  };
  const activeVariant =
    featureAnimations[active.title] || featureAnimations["Devtas calculation"];

  return (
    <div className="bg-slate-50">
      <SEO
        title={featuresData.seo?.title}
        description={featuresData.seo?.description}
        ogType="website"
        ogImage={featuresData.seo?.ogImage}
      />
      <section className="section-padding mx-auto w-full max-w-6xl">
        {/* <!-- Replace with dynamic content from JSON --> */}
        <p className="text-sm uppercase tracking-[0.2em] text-amber-600">
          {featuresData.seo?.title}
        </p>
        <h1 className="page-title mt-3">
          {featuresData.headline}
        </h1>
        <p className="mt-4 text-lg text-slate-600">
          {featuresData.seo?.description}
        </p>
        <NavLink
          to="/pricing"
          className="mt-4 inline-block text-sm font-semibold text-amber-600 transition hover:text-amber-500"
          onClick={() =>
            logActivity("internal_link", { from: "features", to: "pricing" })
          }
        >
          {featuresData.pricingLinkLabel}
        </NavLink>
      </section>

      <section className="section-padding bg-white">
        <div className="mx-auto grid w-full max-w-6xl gap-10 md:grid-cols-[0.9fr_1.1fr]">
          <div className="space-y-3">
            {/* <!-- Replace with dynamic content from JSON --> */}
            {featuresData.features.map((feature) => (
              <button
                key={feature.title}
                onClick={() => setActive(feature)}
                className={`card flex w-full items-start justify-between px-5 py-4 text-left transition ${
                  active.title === feature.title
                    ? "border-amber-500 text-slate-900 shadow-md"
                    : "text-slate-600 hover:border-amber-300"
                }`}
              >
                <div>
                  <p className="text-base font-semibold">{feature.title}</p>
                  <p className="mt-2 text-sm text-slate-500">
                    {feature.description}
                  </p>
                </div>
                <span className="text-amber-500">→</span>
              </button>
            ))}
          </div>

          <motion.div
            key={active.title}
            className="card p-8"
            variants={activeVariant}
            initial="hidden"
            animate="visible"
          >
            <h3 className="text-xl font-semibold text-slate-900">
              {active.title}
            </h3>
            <p className="mt-3 text-sm text-slate-600">{active.details}</p>
            <div className="mt-6 grid gap-4 md:grid-cols-3">
              <div className="card p-4">
                <p className="text-sm text-slate-600">{active.description}</p>
              </div>
              <div className="card p-4">
                <p className="text-sm text-slate-600">{active.details}</p>
              </div>
              <div className="card p-4">
                <p className="text-sm text-slate-600">
                  {featuresData.seo?.description}
                </p>
              </div>
            </div>
            <div className="mt-6">
              <VastuCompassPlaceholder />
              <p className="mt-3 text-xs text-slate-500">
                {featuresData.seo?.description}
              </p>
            </div>
            {/* <!-- Replace with dynamic content from JSON --> */}
          </motion.div>
        </div>
      </section>
    </div>
  );
}
